import { jsx as _jsx } from "preact/jsx-runtime";
import { useMemo } from 'react';
import convertDataAttributes from '@bookingForm/convertDataAttributes';
import defaultValues from '@widgets/DayTickets/context/defaultValues';
import defaultTheme from '@bookingForm/themes/default';
import productTheme from '@bookingForm/themes/product';
import { multiActivitySchema, } from '@widgets/GenericBookings/validation/schema';
import BookingFormWrapper from '@genericBookings/components/BookingFormWrapper';
import StaticFormSteps from '@genericBookings/types/StaticFormSteps';
import Form from '@widgets/DayTickets/components/Form/Form';
import { OptionsCTX, optionsDefaults } from './context/Options';
function DayTickets(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...formattedAttributes,
        isMulti: true,
        isBuilder: false,
        debug: false,
    }), [formattedAttributes]);
    const { dayTicketId, hideQuickPayButtons, activities } = formOptions;
    return (_jsx(BookingFormWrapper, { schema: multiActivitySchema, defaultValues: {
            ...defaultValues,
            DayTicketId: dayTicketId ?? 217,
            acceptTerms: hideQuickPayButtons ? true : defaultValues.acceptTerms,
            Sessions: activities.map((theActivity) => ({
                ActivityId: theActivity.id ?? undefined,
                SessionId: null,
            })),
        }, steps: StaticFormSteps, options: formOptions, OptionsCTX: OptionsCTX, theme: {
            ...defaultTheme,
            ...productTheme,
            layout: 'rework' ?? 'winter-wonderland',
        }, children: _jsx(Form, {}) }));
}
export default DayTickets;
